import { z } from 'zod';

export const Location = z.object({
    name: z.string(),
    countryCode: z.string(),
    utcOffsetMinutes: z.number(),
    placeId: z.string(),
    placeResult: z.unknown().optional(),
    placePrediction: z.unknown().optional(),
});
export type Location = z.infer<typeof Location>;
